import PageStructure, { PageContent } from "@pages/PageStructure.component";
import { Outlet } from "react-router-dom";

const SourcesWrapperPage = () => {
    return <PageStructure>
        <Outlet/>
    </PageStructure>
}

export default SourcesWrapperPage;